import type { TranslationDict } from '../types'

export const account: TranslationDict = {
  page: {
    title: {
      en: 'Account Center',
      'zh-CN': '账户中心',
      ja: 'アカウントセンター',
    },
    subtitle: {
      en: 'Membership, balances, and more.',
      'zh-CN': '会员、余额与更多信息。',
      ja: 'メンバーシップと残高など。',
    },
    loading: {
      en: 'Loading...',
      'zh-CN': '加载中...',
      ja: '読み込み中...',
    },
  },
  common: {
    retry: {
      en: 'Retry',
      'zh-CN': '重试',
      ja: '再試行',
    },
    comingSoon: {
      en: 'Coming Soon',
      'zh-CN': '敬请期待',
      ja: '近日公開',
    },
  },
  sections: {
    profile: {
      title: {
        en: 'Profile',
        'zh-CN': '个人资料',
        ja: 'プロフィール',
      },
      edit: {
        en: 'Edit',
        'zh-CN': '编辑',
        ja: '編集',
      },
      viewProfile: {
        en: 'View Profile',
        'zh-CN': '查看主页',
        ja: 'プロフィールを見る',
      },
      settings: {
        en: 'Settings',
        'zh-CN': '设置',
        ja: '設定',
      },
    },
    membership: {
      title: {
        en: 'Membership & Quota',
        'zh-CN': '会员与配额',
        ja: 'メンバーシップ・クォータ',
      },
      loading: {
        en: 'Loading membership...',
        'zh-CN': '加载会员信息中...',
        ja: 'メンバーシップを読み込み中...',
      },
      error: {
        en: 'Failed to load membership: {{message}}',
        'zh-CN': '会员信息加载失败：{{message}}',
        ja: 'メンバーシップの読み込みに失敗しました: {{message}}',
      },
      empty: {
        en: 'No membership data.',
        'zh-CN': '暂无会员数据。',
        ja: 'メンバーシップ情報がありません。',
      },
    },
    balance: {
      title: {
        en: 'Balance',
        'zh-CN': '余额',
        ja: '残高',
      },
      loading: {
        en: 'Loading balance...',
        'zh-CN': '加载余额中...',
        ja: '残高を読み込み中...',
      },
      error: {
        en: 'Failed to load balance: {{message}}',
        'zh-CN': '余额加载失败：{{message}}',
        ja: '残高の読み込みに失敗しました: {{message}}',
      },
    },
    transactions: {
      title: {
        en: 'Transactions',
        'zh-CN': '交易记录',
        ja: '取引履歴',
      },
      loading: {
        en: 'Loading transactions...',
        'zh-CN': '加载交易记录中...',
        ja: '取引履歴を読み込み中...',
      },
      loadingMore: {
        en: 'Loading more...',
        'zh-CN': '加载更多中...',
        ja: 'さらに読み込み中...',
      },
      loadMore: {
        en: 'Load more',
        'zh-CN': '加载更多',
        ja: 'さらに読み込む',
      },
      error: {
        en: 'Failed to load transactions: {{message}}',
        'zh-CN': '交易记录加载失败：{{message}}',
        ja: '取引履歴の読み込みに失敗しました: {{message}}',
      },
      empty: {
        en: 'No transactions yet.',
        'zh-CN': '暂无交易记录。',
        ja: '取引履歴はまだありません。',
      },
    },
    dealer: {
      title: {
        en: 'Distributor',
        'zh-CN': '代理商',
        ja: '代理店',
      },
      loading: {
        en: 'Loading distributor info...',
        'zh-CN': '加载代理信息中...',
        ja: '代理店情報を読み込み中...',
      },
      error: {
        en: 'Failed to load distributor info: {{message}}',
        'zh-CN': '代理信息加载失败：{{message}}',
        ja: '代理店情報の読み込みに失敗しました: {{message}}',
      },
      empty: {
        en: 'No distributor data.',
        'zh-CN': '暂无代理数据。',
        ja: '代理店情報がありません。',
      },
    },
    ads: {
      title: {
        en: 'Ads',
        'zh-CN': '广告',
        ja: '広告',
      },
      loading: {
        en: 'Loading ads info...',
        'zh-CN': '加载广告信息中...',
        ja: '広告情報を読み込み中...',
      },
      error: {
        en: 'Failed to load ads info: {{message}}',
        'zh-CN': '广告信息加载失败：{{message}}',
        ja: '広告情報の読み込みに失敗しました: {{message}}',
      },
      empty: {
        en: 'No ads data.',
        'zh-CN': '暂无广告数据。',
        ja: '広告情報がありません。',
      },
    },
  },
  transactions: {
    description: {
      tip_received: {
        en: 'Tip from {{from}}',
        'zh-CN': '来自 {{from}} 的打赏',
        ja: '{{from}} からのチップ',
      },
      tip_sent: {
        en: 'Tip to {{to}}',
        'zh-CN': '打赏给 {{to}}',
        ja: '{{to}} へのチップ',
      },
      tip_withdraw: {
        en: 'Withdrawal to account',
        'zh-CN': '提现到账户',
        ja: 'アカウントへ出金',
      },
      tip_platform_fee: {
        en: 'Platform fee',
        'zh-CN': '平台服务费',
        ja: 'プラットフォーム手数料',
      },
      recharge: {
        en: 'Account top-up',
        'zh-CN': '账户充值',
        ja: 'アカウントチャージ',
      },
      account_credit: {
        en: 'Account credit',
        'zh-CN': '账户入账',
        ja: '入金',
      },
      account_debit: {
        en: 'Account debit',
        'zh-CN': '账户扣款',
        ja: '出金',
      },
      transaction: {
        en: 'Transaction',
        'zh-CN': '交易',
        ja: '取引',
      },
    },
  },
  dealer: {
    cta: {
      title: {
        en: 'Become a distributor',
        'zh-CN': '成为代理商',
        ja: '代理店になる',
      },
      body: {
        en: 'Earn commission by referring and supporting new users.',
        'zh-CN': '通过推广与支持新用户赚取佣金。',
        ja: '紹介やサポートでコミッションを獲得できます。',
      },
      button: {
        en: 'Learn more',
        'zh-CN': '了解更多',
        ja: '詳細を見る',
      },
    },
    summary: {
      title: {
        en: 'Distributor summary',
        'zh-CN': '代理概览',
        ja: '代理店サマリー',
      },
      name: {
        en: 'Account: {{name}}',
        'zh-CN': '账户：{{name}}',
        ja: 'アカウント: {{name}}',
      },
      tier: {
        en: '{{tier}}',
        'zh-CN': '{{tier}}',
        ja: '{{tier}}',
      },
      walletAvailable: {
        en: 'Available balance',
        'zh-CN': '可用余额',
        ja: '利用可能残高',
      },
      walletPending: {
        en: 'Pending balance',
        'zh-CN': '待结算',
        ja: '保留中',
      },
      commissionThisMonth: {
        en: "This month's commission",
        'zh-CN': '本月佣金',
        ja: '今月のコミッション',
      },
      commissionTotal: {
        en: 'Total earned',
        'zh-CN': '累计收入',
        ja: '累計獲得',
      },
      teamDirect: {
        en: 'Direct',
        'zh-CN': '直属',
        ja: '直下',
      },
      teamActiveLeads: {
        en: 'Active leads',
        'zh-CN': '活跃线索',
        ja: '進行中リード',
      },
      teamWonLeads: {
        en: 'Won leads',
        'zh-CN': '成交线索',
        ja: '成約',
      },
      openPortal: {
        en: 'Open portal',
        'zh-CN': '打开代理后台',
        ja: 'ポータルを開く',
      },
    },
  },
  ads: {
    cta: {
      title: {
        en: 'Start advertising',
        'zh-CN': '开始投放广告',
        ja: '広告を始める',
      },
      body: {
        en: 'Promote your content and reach more people.',
        'zh-CN': '推广内容，触达更多人群。',
        ja: 'コンテンツを宣伝してより多くの人に届けましょう。',
      },
      button: {
        en: 'Get started',
        'zh-CN': '立即开始',
        ja: '始める',
      },
    },
    summary: {
      title: {
        en: 'Ads summary',
        'zh-CN': '广告概览',
        ja: '広告サマリー',
      },
      status: {
        en: 'Status: {{status}}',
        'zh-CN': '状态：{{status}}',
        ja: 'ステータス: {{status}}',
      },
      tier: {
        en: '{{tier}}',
        'zh-CN': '{{tier}}',
        ja: '{{tier}}',
      },
      balance: {
        en: 'Balance',
        'zh-CN': '余额',
        ja: '残高',
      },
      monthlySpend: {
        en: 'This month spent',
        'zh-CN': '本月花费',
        ja: '今月の支出',
      },
      campaignsActive: {
        en: 'Active campaigns',
        'zh-CN': '进行中活动',
        ja: '稼働中キャンペーン',
      },
      impressions: {
        en: 'Impressions',
        'zh-CN': '展示',
        ja: '表示回数',
      },
      clicks: {
        en: 'Clicks',
        'zh-CN': '点击',
        ja: 'クリック',
      },
      openPortal: {
        en: 'Open ads manager',
        'zh-CN': '打开广告后台',
        ja: '広告マネージャーを開く',
      },
    },
  },
  membership: {
    expires: {
      en: 'Expires {{date}}',
      'zh-CN': '到期 {{date}}',
      ja: '{{date}} まで',
    },
    upgradePlan: {
      en: 'Upgrade Plan',
      'zh-CN': '升级会员',
      ja: 'プランをアップグレード',
    },
    usedOf: {
      en: '{{used}} / {{limit}}',
      'zh-CN': '{{used}} / {{limit}}',
      ja: '{{used}} / {{limit}}',
    },
    na: {
      en: 'N/A',
      'zh-CN': 'N/A',
      ja: 'N/A',
    },
    tier: {
      free: { en: 'Free', 'zh-CN': 'Free', ja: 'Free' },
      starter: { en: 'Starter', 'zh-CN': 'Starter', ja: 'Starter' },
      pro: { en: 'Pro', 'zh-CN': 'Pro', ja: 'Pro' },
      business: { en: 'Business', 'zh-CN': 'Business', ja: 'Business' },
    },
    quota: {
      a2a: { en: 'A2A', 'zh-CN': 'A2A', ja: 'A2A' },
      human_chat: { en: 'Chat', 'zh-CN': '对话', ja: 'チャット' },
      ai_posts: { en: 'Posts', 'zh-CN': '帖子', ja: '投稿' },
      ai_comments: { en: 'Comments', 'zh-CN': '评论', ja: 'コメント' },
      silicon_avatar: { en: 'Avatar', 'zh-CN': '分身', ja: 'アバター' },
    },
  },
  balance: {
    tokenBalance: {
      en: 'Token Balance',
      'zh-CN': 'Token 余额',
      ja: 'トークン残高',
    },
    tipsEarned: {
      en: 'Tips Earned',
      'zh-CN': '打赏收入',
      ja: 'チップ収益',
    },
    withdraw: {
      en: 'Withdraw',
      'zh-CN': '提现',
      ja: '出金',
    },
  },
  withdraw: {
    title: {
      en: 'Withdraw tips',
      'zh-CN': '确认提现',
      ja: 'チップを出金',
    },
    body: {
      en: 'You are about to withdraw {{amount}} tips.',
      'zh-CN': '你将提现吗：{{amount}}',
      ja: '{{amount}} チップを出金します。',
    },
    confirm: {
      en: 'Confirm',
      'zh-CN': '确认',
      ja: '確認',
    },
    confirming: {
      en: 'Confirming...',
      'zh-CN': '确认中...',
      ja: '処理中...',
    },
    success: {
      en: 'Withdrawal requested.',
      'zh-CN': '已发起提现。',
      ja: '出金をリクエストしました。',
    },
    failed: {
      en: 'Withdrawal failed: {{message}}',
      'zh-CN': '提现失败：{{message}}',
      ja: '出金に失敗しました: {{message}}',
    },
  },
}
